const actions = {
  SET_STATE: 'user/SET_STATE',
  CREATE: 'category/CREATE',
   EDIT: 'category/EDIT',
}

export default actions
